<template>
  <div class="wrapper" v-if="state.login">
    <DashboardView :menu="state.menuState" @toggleMenu="toggleMenu()"/>
    <TopNavigation @noteClick="noteClick"
      @toggleMenu="toggleMenu()" :menu="state.menuState"/>
    <div v-if="state.login" class="main-content" :class="{'open' : state.menuState}">
      <router-view />
    </div>
  </div>
  <div v-if="!state.login">Loading</div>
</template>

<script>
import DashboardView from './components/DashboardView.vue';
import { computed, reactive } from "vue";
import { useDarkMode } from "./composables/useDarkMode.js";
import TopNavigation from './components/TopNavigation.vue';
import {useStore} from "vuex";
import { urls } from "@/assets/js/urls";
import call from "@/composables/call.js";
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
export default {
  name: 'App',
  components:{
    DashboardView,TopNavigation
  },
  setup() {
    const router = useRouter();
    const store=useStore();
    const user=computed(()=>store.state.User.user);
    const state=reactive({login:false, menuState:true})
    const { darkMode, applyDarkMode } = useDarkMode("");
    const route = useRoute();
    const activePage = computed(() => route.name ?? 'Unknown Page');

    function verifySess(){
      const update = {verifySess: "verifySess"};
      const options = {method: 'POST',headers: {'Content-Type': 'application/json'},credentials:"include", body: JSON.stringify(update)};
      fetch(urls.dashboard, options).then(data => {
          if (!data.ok) {
              throw Error(data);
          }
          return data.json();
      }).then(res => {
        if(!res.session){
          window.location=urls.base;
        }else if(res.redirect){
          window.location=res.redirect;
          return;
        }else if(res.reroute){
          if(activePage.value != res.reroute){
            router.replace({ name: res.reroute });
          }
          setStage(res)
        }else{
          setStage(res)
        }
      }).catch(()=> {
        window.location=urls.base;
      });
    }

    function setStage(res){
      var r=res.data.msg
      var user={
        name:r.name,
        dp:r.dp,
        persona:r.persona,
        links:r.links,
        username:r.usrid
      }
      var userpp={
        note:r.note,
        noteLoaded:false
      }
      var notes=r.notes;
      var login={
          status:true,
          auth_code:r.auth_code,
          notes:notes
      }
      
      var system={
        sub:r.sub,
        c:r.c,
        am:r.csm,
        oname:r.office_name,
        acct_type:r.acct_type
      }
      
      store.dispatch("Login/setLogin",login);
      store.dispatch("User/setUser",user);
      store.dispatch("User/setUserApp",userpp);
      store.dispatch("System/setSystem",system);
      state.login=true;
      //working on the dark mode status
      if(r.darkMode =="sys"){
        localStorage.removeItem("user-dark-mode");
      }else{
          localStorage.setItem("user-dark-mode", r.darkMode);
      }
    }

    function toggleMenu(){
      state.menuState=!state.menuState
    }

    function noteClick(n){
      if(n.status =="1"){
        call({
            url:urls.dashboard,
            data:{markNote:n.id},
            success:(res)=>{
              if(res.status){
                var login={
                    status:true,
                    auth_code:res.msg.auth_code,
                    notes:res.msg.notes
                }
                store.dispatch("Login/setLogin",login);
              }
            }
        })
      }
      if(n.app =="Task"){
          router.push({ name: 'mytasks'});
      }
      if(n.app =="Project"){
          router.push({ name: 'projectsview'});
      }
    }

    return { darkMode,state,applyDarkMode, user, verifySess,toggleMenu,noteClick };
  },
  beforeCreate: function(){
    this.verifySess();
  }
}
</script>
<style>
@import url("./assets/css/fonts.css");
@import url("./assets/css/vixcss.css");
@import url("./assets/css/main.css");

</style>